export const parseWebhookTagValues = (input: string): string[] => {
  return Array.from(
    new Set(
      input
        .split(',')
        .map((tag) => tag.trim())
        .filter((tag) => tag.length > 0),
    ),
  );
};

export const buildWebhookSnippet = (webhookEndpoint: string, tags: string[]): string => {
  const header = tags.length > 0 ? [`# key tags: ${tags.join(', ')}`] : [];
  return [
    ...header,
    'curl --request POST \\\\',
    `  "${webhookEndpoint}" \\\\`,
    '  --header "x-webhook-token: $WEBHOOK_KEY" \\\\',
    '  --header "content-type: application/json" \\\\',
    '  --data \'{"object_kind":"pipeline","object_attributes":{"id":42,"ref":"main","source":"push","status":"success"}}\'',
  ].join('\n');
};
